import React, { useState } from "react";

//Assets 
import LogoCol from "../img/logo_colsubsidio.png";
import MainBk from "../img/viviendas_construccion/6.Fondo-ProyectosConstruccion.jpg";
import ImageMacarena from "../img/viviendas_construccion/6.Capsula-PC-Macarena.png";
import ImageMongui from "../img/viviendas_construccion/6.Capsula-PC-Mogui.png";
import ImagePamplona from "../img/viviendas_construccion/6.Capsula-PC-Pamplona.png";

//Data Display
import TopLeftTitle from "../data_display/TopLeftTitle";
import ButtonLeftTitle from "../data_display/BottomLeftTitle";
import MiniaturePreview from "../data_display/MiniaturePreview";
import PointDefault from "../data_display/PointLocation";

//Inputs
import HomeButton from "../inputs/HomeButton";

//Navigation
import MenuMiniatures from "../navigation/MenuMiniatures";

const listMiniatures = [{
    id: "1",
    title:"702",
    subtitle:"Unidades",
    image: ImageMacarena,
    x: "58%",
    y: "39%",
    link: "https://www.colsubsidio.com/vivienda/proyectos/proyecto/macarena"
}, {
    id: "2",
    title:"860",
    subtitle:"Unidades",
    image: ImageMongui,
    x: "53%",
    y: "35%",
    link: "https://www.colsubsidio.com/vivienda/proyectos/proyecto/mongui-maipore"
}, {
    id: "3",
    title:"960",
    subtitle:"Unidades",
    image: ImagePamplona,
    x: "27%",
    y: "46%",
    link: "https://www.colsubsidio.com/vivienda/proyectos/proyecto/pamplona"
}];

export default function ViviendasConstruccionPage () {
    const [currentItem, SetCurrentItem] = useState(0);

    function onClickMiniature(tmpIndex)
    {
        SetCurrentItem(tmpIndex);
    }

    function onClickPreview(tmpLink)
    {
        console.log("Onclick: ", tmpLink);
        window.open(tmpLink, "_blank");
    }

    return (
        <div style={{width:"100%", height:"100%", backgroundImage:"url("+MainBk+")", backgroundSize:"contain"}}>
            <div style={{position:"absolute", right:"80px", top:"20px", width:"200px"}}>
                <img src={LogoCol} style={{width:"100%"}}/>
            </div>
            <TopLeftTitle title={"PROYECTOS EN DESARROLLO"} subtitle={""} />
            <ButtonLeftTitle title={"4.065"} subtitle={"Unidades"} />
            <HomeButton/>
            <MiniaturePreview item={listMiniatures[currentItem]} link={listMiniatures[currentItem].link}
            onClick={onClickPreview}/>
            <MenuMiniatures items={listMiniatures} selected={currentItem} onClick={onClickMiniature}/>
            {
                listMiniatures.map((item, index)=>{
                    return (<PointDefault key={item.id} id={item.id} 
                        x={item.x} y={item.y} index={index}
                        onClick={onClickMiniature}
                        selected={index === currentItem ? true:false}/>
                    )
                })
            }
        </div>
    );
}